const mediaItems = [
  {
    title: '创造营三公：黑马选手逆袭全记录',
    duration: '12:38',
    views: '128万',
    tag: '热门',
    img: 'https://readdy.ai/api/search-image?query=A%20stylized%20editorial%20video%20thumbnail%20showing%20a%20dynamic%20stage%20performance%20with%20spotlights%20and%20silhouettes%2C%20warm%20coral%20and%20amber%20color%20grading%2C%20minimalist%20composition%20with%20clean%20lines%2C%20entertainment%20show%20aesthetic%2C%20abstract%20crowd%20silhouettes%20in%20the%20background%2C%20soft%20dramatic%20lighting%2C%20modern%20editorial%20design&width=640&height=360&seq=media-card-01&orientation=landscape',
  },
  {
    title: '电竞世界杯：黑马战队赛后独家采访',
    duration: '08:15',
    views: '96万',
    tag: '独家',
    img: 'https://readdy.ai/api/search-image?query=A%20stylized%20esports%20gaming%20arena%20scene%20with%20colorful%20LED%20lights%20and%20gaming%20setup%20silhouettes%2C%20warm%20amber%20and%20coral%20color%20palette%2C%20clean%20minimalist%20composition%2C%20abstract%20cyberpunk%20inspired%20patterns%2C%20professional%20esports%20aesthetic%2C%20soft%20dramatic%20lighting%20with%20neon%20accents&width=640&height=360&seq=media-card-02&orientation=landscape',
  },
  {
    title: '歌手2026第六期：替补赛制全程回顾',
    duration: '15:42',
    views: '203万',
    tag: '热播',
    img: 'https://readdy.ai/api/search-image?query=A%20stylized%20music%20stage%20with%20dramatic%20lighting%20and%20microphone%20stand%20silhouette%2C%20warm%20golden%20and%20coral%20color%20gradient%2C%20minimalist%20editorial%20composition%2C%20concert%20atmosphere%20with%20abstract%20light%20beams%2C%20professional%20music%20show%20aesthetic%2C%20soft%20atmospheric%20haze&width=640&height=360&seq=media-card-03&orientation=landscape',
  },
];

export default function SectionMedia() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="flex items-center justify-between mb-10">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">
              视频精选
            </h2>
            <p className="text-sm text-foreground-500 mt-2">每日大赛最新视频内容，精彩不容错过</p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {mediaItems.map((item, i) => (
            <div key={i} className="group cursor-pointer">
              <div className="relative aspect-video rounded-xl overflow-hidden bg-secondary-100 mb-4">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover object-top"
                  onError={(e) => {
                    (e.target as HTMLElement).style.display = 'none';
                  }}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent"></div>
                <span className="absolute bottom-3 right-3 px-2 py-1 rounded-md bg-black/60 text-white text-[11px] font-medium whitespace-nowrap">
                  {item.duration}
                </span>
                <span className="absolute top-3 left-3 px-2 py-0.5 rounded-full bg-primary-500 text-white text-[11px] font-medium whitespace-nowrap">
                  {item.tag}
                </span>
                <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-200">
                  <div className="w-14 h-14 rounded-full bg-white/90 flex items-center justify-center">
                    <i className="ri-play-fill text-2xl text-primary-500 ml-0.5"></i>
                  </div>
                </div>
              </div>
              <h3 className="font-heading text-base text-foreground-900 mb-1.5 group-hover:text-primary-500 transition-colors duration-200">
                {item.title}
              </h3>
              <span className="text-xs text-foreground-400 whitespace-nowrap">{item.views} 次观看</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}